import { QueryFilterComparisonType, } from '../../../types';
/* Type Guards */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export var isNumberArray = function (value) {
    return value instanceof Array && value.every(function (item) { return typeof item === 'number'; });
};
export var isCosineSimilarityQueryValue = function (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
value) {
    return isNumberArray(value.vector) && typeof value.threshold === 'number';
};
export var isLogRegQueryValue = function (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
value) {
    return isNumberArray(value.vector) &&
        typeof value.threshold === 'number' &&
        typeof value.bias === 'number';
};
export var isCosineSimilarityFilterType = function (query) {
    return (query.queryFilterComparisonType ===
        QueryFilterComparisonType.COSINE_SIMILARITY &&
        isCosineSimilarityQueryValue(query.queryValue));
};
export var isLogisticRegressionFilterType = function (query) {
    return (query.queryFilterComparisonType ===
        QueryFilterComparisonType.LOGISTIC_REGRESSION &&
        isLogRegQueryValue(query.queryValue));
};
//# sourceMappingURL=guards.js.map